<template>
    <div class="ancho">
        <div style="padding:60.25% 0 0 0;position:relative;"><iframe
                src="https://player.vimeo.com/video/396986028?title=0&byline=0&portrait=0"
                style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0"
                allow="autoplay; fullscreen" allowfullscreen></iframe>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    export default {
        name: 'videoPostWebinar',
        components: {

        },
        created(){

        },
        data(){
            return {

            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style scoped>
    .ancho{
        width: 70%;

    }
    @media screen and (max-width: 768px) {
        .ancho{
            width: 96%;
            padding: 0 50px;
        }
    }
</style>